import { writable } from 'svelte/store';

export const config = writable([]);
export const selectedNode = writable(null);